module.exports = __webpack_public_path__ + "img/00013.96c180a7.webp";